import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from './core/auth/auth.service';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { SpinnerComponent } from './core/spinner/spinner.component';

@Component({
  selector: 'signpost-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, AsyncPipe, SpinnerComponent]
})
export class AppComponent implements OnInit {
  authService = inject(AuthService);

  ngOnInit() {
    if (!this.isAllowed()) {
      this.authService.initAuth();
    }
  }

  isAllowed(): boolean {
    const currentPath = window.location.pathname;
    const publicRoutes = ['/error', '/logout'];

    return publicRoutes.includes(currentPath);
  }
}
